import { render, staticRenderFns } from "./DkBadgeDST.vue?vue&type=template&id=4d4c4474&"
import script from "./DkBadgeDST.vue?vue&type=script&lang=js&"
export * from "./DkBadgeDST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports